/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	BulkCandidateWhatsAppStoreRequest,
	BulkCandidateWhatsAppStoreResponse,
} from '../types/BulkCandidateWhatsAppStore'

/**
 * POST /candidates/bulk-whatsapp
 * @see backend/nexus/modules/Campaign/Http/Controllers/BulkCandidateWhatsAppController.php BulkCandidateWhatsAppController::store
 */
export async function bulkCandidateWhatsAppStore(
	data: BulkCandidateWhatsAppStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BulkCandidateWhatsAppStoreResponse>> {
	return axiosInstance.post('/candidates/bulk-whatsapp', data, config)
}
